import { Link } from "react-router-dom";
import { MapPin, Phone, Globe, ArrowRight, ShieldCheck, Star } from "lucide-react";
import { imgUrl } from "@/lib/api";

function normUrl(v) {
  if (!v) return null;
  return v.startsWith("http") ? v : "https://" + v;
}

/** Responsive grid of approved firm business cards. */
export default function FirmCards({ firms = [] }) {
  if (!firms.length) return null;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="firm-cards">
      {firms.map((f) => {
        const ref = (f.references || []).find((r) => r.image_after || r.image);
        const cover = ref ? (ref.image_after || ref.image) : "";
        return (
          <Link key={f.id} to={`/firma/${f.slug}`} data-testid={`firm-card-${f.slug}`}
            className="group border border-white/10 bg-ink-2 flex flex-col overflow-hidden hover:border-gold/50 transition-colors">
            <div className="aspect-[16/10] bg-ink overflow-hidden relative">
              {cover ? (
                <img src={imgUrl(cover)} alt={f.company} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gold/5"><ShieldCheck className="w-10 h-10 text-gold/40" /></div>
              )}
              {f.featured && (
                <span className="absolute top-2 left-2 bg-gold text-ink text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 flex items-center gap-1">
                  <Star className="w-3 h-3 fill-ink" /> Odporúčaná
                </span>
              )}
              {f.logo && (
                <img src={imgUrl(f.logo)} alt="" className="absolute bottom-2 right-2 h-10 w-10 object-contain bg-white/90 p-1" />
              )}
            </div>
            <div className="p-4 flex flex-col flex-1">
              <div className="flex items-center gap-1.5 text-gold text-[11px] font-mono2 uppercase tracking-widest mb-1">
                <MapPin className="w-3 h-3" /> {f.district}
              </div>
              <h3 className="text-white font-bold text-lg leading-tight">{f.company}</h3>
              {f.bio && <p className="text-white/50 text-sm mt-1.5 line-clamp-2 flex-1">{f.bio}</p>}
              <div className="flex items-center justify-between mt-3 pt-3 border-t border-white/5">
                <div className="flex items-center gap-3 text-white/40 text-xs">
                  {f.phone && <span className="flex items-center gap-1"><Phone className="w-3 h-3" /> Tel.</span>}
                  {f.website && <a href={normUrl(f.website)} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} className="flex items-center gap-1 hover:text-gold"><Globe className="w-3 h-3" /> Web</a>}
                </div>
                <span className="text-gold text-xs font-bold uppercase tracking-widest flex items-center gap-1">Vizitka <ArrowRight className="w-3 h-3 group-hover:translate-x-0.5 transition-transform" /></span>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
